var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReviewIcon = function SvgReviewIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.222 4H5.778C4.8 4 4 4.8 4 5.778v12.444C4 19.2 4.8 20 5.778 20h12.444C19.2 20 20 19.2 20 18.222V5.778C20 4.8 19.2 4 18.222 4ZM9.333 16.044a.4.4 0 0 1-.4.4h-.977a.4.4 0 0 1-.4-.4v-5.422c0-.22.179-.4.4-.4h.977c.221 0 .4.18.4.4v5.422Zm3.556 0a.4.4 0 0 1-.4.4h-.978a.4.4 0 0 1-.4-.4V7.956c0-.221.18-.4.4-.4h.978c.22 0 .4.179.4.4v8.088Zm3.555 0a.4.4 0 0 1-.4.4h-.977a.4.4 0 0 1-.4-.4V13.29c0-.221.179-.4.4-.4h.977a.4.4 0 0 1 .4.4v2.755Z",
    fill: "#797CDB"
  })));
};
export default SvgReviewIcon;